export default __webpack_public_path__ + "favicon-16x16.5b4707491786b50c82fff3db9cbe6dc7.png";